import { render, staticRenderFns } from "./alunoCollapse.vue?vue&type=template&id=4e5bc942"
import script from "./alunoCollapse.vue?vue&type=script&lang=js"
export * from "./alunoCollapse.vue?vue&type=script&lang=js"
import style0 from "./alunoCollapse.vue?vue&type=style&index=0&id=4e5bc942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports